<template>
  <div class="slider_container">
    <div class="header">
      <div class="num">{{ index }}</div>
      <div class="text ellipsis">{{ getSlideTitle(index) }}</div>
    </div>
    <div ref="slider" class="content">
      <slot></slot>
    </div>
    <div class="control" v-if="count > 1">
      <button class="switcher" @click="goBack()" :disabled="index === 1">Назад</button>
      <button class="switcher" @click="goForward()" :disabled="forwardDisabled">Вперед</button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["modelValue", "style", 'disableds'],
  emits: ["update:modelValue", "slide"],

  data() {
    return {
      index: 1,
    };
  },

  computed: {
    forwardDisabled() {
      return (this.index > this.count - 1) || this.disableds[this.index-1+1]
    },
    count() {
      if (this.style === "desktop") return this.getSlideCount() - 1;
      return this.getSlideCount();
    },
  },

  mounted() {
    this.goTo(this.modelValue, true);
  },

  watch: {
    style(new_value, old_value) {
      if (old_value === "mobile" && new_value === "desktop" && this.index === this.getSlideCount()) {
        this.goTo(this.getSlideCount() - 1);
      }
    },
  },

  methods: {
    getSlideCount() {
      if (!this.$refs.slider) return [];
      if (!this.$refs.slider.children) return [];
      return this.$refs.slider.children.length;
    },

    getSlideTitle(index) {
      if (!this.$refs.slider) return "";
      if (!this.$refs.slider.children) return "";
      return this.$refs.slider.children[index - 1].title;
    },

    goBack() {
      if (this.index === 1) return;
      this.goTo(this.index - 1);
    },

    goForward() {
      if (this.index > this.count - 1) return this.count;
      this.goTo(+this.index + 1);
    },

    goTo(index, init = false) {
      this.index = index;
      this.$emit("update:modelValue", this.index);
      if (!init) {
        this.$emit("slide", this.index);
      }
    },
  },
};
</script>

<style scoped>
.slider_container {
  flex-grow: 1;
  flex-shrink: 1;
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
}

.slider_container > .header {
  font-weight: bold;
  padding: 5px;
  background: #fc5a0a;
  margin: 5px 0 0;
  border-radius: 20px;

  display: flex;
  align-content: center;
  justify-content: flex-start;
  position: relative;
  width: auto;
}

.slider_container > .header > .num {
  position: absolute;
  background: white;
  border-radius: 50%;
  padding: 3px 10px;
  font-size: 14pt;
}

.slider_container > .header > .text {
  margin: auto 35px;
  flex-grow: 1;
  text-align: center;
  padding: 5px 0;
  color: black;
}

.slider_container > .content {
  flex-grow: 1;
  display: flex;
  overflow: hidden;
  overflow-y: auto;
  margin: 5px 0;
  border: 1px solid lightgray;
}

.slider_container > .control {
  display: flex;
  justify-content: space-between;
}

.slider_container > .control > .switcher {
  font-size: 14pt;
  color: white;
  background: #fc5a0a;
  border: none;
  border-radius: 50px;
  padding: 3px 24px;
  text-align: center;
  cursor: pointer;
  opacity: 0.9;
}

.slider_container > .control > .switcher:hover {
  opacity: 1;
}

.slider_container > .control > .switcher:disabled {
  background: lightgray;
}

.slider_container > .control > .marker {
  margin: auto;
  display: flex;
  position: relative;
  border: none;
}

.slider_container > .control > .marker > button {
  margin: auto;

  cursor: pointer;
  color: black;
  border: 2px solid lightgrey;
  border-radius: 50%;

  padding: 0 4px;
  text-align: center;
  background: rgba(0, 0, 0, 0.05);
  z-index: 2;
  background: white;
}

.slider_container > .control > .marker > button:hover {
  color: black;
  font-weight: 700;
  border: 2px solid #fc5a0a;
}

.slider_container > .control > .marker > button[disabled] {
  color: grey;
  font-weight: 700;
  border: 2px solid grey;
}

.slider_container > .control > .marker > button:hover::after {
  content: attr(title2);
  position: absolute;
  width: 100px;
  padding: 6px 0;
  top: -41px;
  left: -40px;
  background: #fc5a0a;
  color: white;

  border-radius: 20px;
  box-shadow: 0 0 3px 1px gray;

  text-align: center;
  font-size: 8pt;
  font-weight: normal;
}

.slider_container > .control > .marker > .selected {
  color: black;
  font-weight: 700;
  border: 2px solid #fc5a0a;
}
</style>
